import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { FlexColumn } from "@opensea/ui-kit";
import { StatsTableRowFloorChange, StatsTableRowFloorChangeFragment } from "./StatsTableRowFloorChange";
import { StatsTableRowFloorPrice, StatsTableRowFloorPriceFragment } from "./StatsTableRowFloorPrice";
export const StatsTableRowFloorPriceMobileFragment = graphql(`
    fragment StatsTableRowFloorPriceMobile on Collection {
      ...StatsTableRowFloorPrice
      ...StatsTableRowFloorChange
    }
  `, [StatsTableRowFloorPriceFragment, StatsTableRowFloorChangeFragment]);
export function StatsTableRowFloorPriceMobileMobile(t0) {
  const $ = _c(10);
  const {
    collection: collectionKey,
    timeframe
  } = t0;
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(StatsTableRowFloorPriceMobileFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  if ($[2] !== collection) {
    t2 = <StatsTableRowFloorPrice collection={collection} />;
    $[2] = collection;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== collection || $[5] !== timeframe) {
    t3 = <StatsTableRowFloorChange collection={collection} timeframe={timeframe} />;
    $[4] = collection;
    $[5] = timeframe;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <FlexColumn className="items-end">{t2}{t3}</FlexColumn>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}